<template>
  <slot v-bind="{ onSuccess, onBefore, onValidate, onError }"></slot>
</template>

<script>
import { isLoading } from '../composables/orderProcess.js'

export default {
  methods: {
    onError() {
      isLoading.value = false
    },
    onSuccess() {
      isLoading.value = false
    },
    onValidate() {
      isLoading.value = false
    },
    onBefore() {
      isLoading.value = true
    }
  },

  mounted() {}
}
</script>
